module.exports = __webpack_public_path__ + "img/NYI-Logo-blue.5aa7d93d.svg";